import { Modal } from 'bootstrap.native';

var infoModal = document.getElementById('info-modal');

if (infoModal && infoModal.getAttribute('data-show-modal') == true) {
    var ModalInstance = new Modal(infoModal);

    ModalInstance.show();
}
